import requests from '../utils/request'


// 搜索商机
export const searchcompany = (data)=>{
    return requests({
        url:'/buyer/business/search',
        method:'post',
        data
    })
}

// 热门商机 按KEY /buyer/business/hot/search
export const searchcompanyAndHot = (data)=>{
    return requests({
        url:'/buyer/business/hot/search?type='+data,
        method:'get',
        data
    })
}
// 优质项目 /buyer/business/company/hot/list
export const companyAndHot = ()=>{
    return requests({
        url:'/buyer/business/company/hot/list',
        method:'get',
    })
}
// 产品分类/buyer/business/project/category
export const business_category = (data) =>{
    return requests({
        url:'/buyer/business/project/category?type='+data,
        method:'get',
    })
}

